import {
  INCIDENT_ROUTE_NAMES,
  MAIN_ROUTES,
} from '@/router/components';
import { BackgroundColors } from '@/@types/types';

const incidentsRoutes = {
  path: '/incidents',
  meta: {
    requiresAuth: true,
    breadCrumb: 'app.navigation-drawer.incidents',
  },
  component: MAIN_ROUTES.INCIDENTS,
  children: [{
    path: '',
    name: 'incidents',
    meta: {
      requiresAuth: true,
      hideBreadCrumb: true,
      breadCrumb: 'app.navigation-drawer.incidents',
      background: BackgroundColors.SECONDARY,
      negativeMargin: true,
    },
    component: () => import('@/views/FrontendNextRouteView.vue'),
  },
  {
    path: 'issue/:issue',
    redirect: {
      name: INCIDENT_ROUTE_NAMES.overview,
    },
  },
  {
    path: 'issue/:issue/overview',
    name: INCIDENT_ROUTE_NAMES.overview,
    props: true,
    meta: {
      requiresAuth: true,
      breadCrumbFromParamName: true,
      params: ['issue', 'name'],
      hideBreadCrumb: true,
      breadCrumb: 'incident.tabs.overview',
      background: BackgroundColors.SECONDARY,
      negativeMargin: true,
    },
    component: () => import('@/views/FrontendNextRouteView.vue'),
  },
  {
    path: 'issue/:issue/monitors',
    name: INCIDENT_ROUTE_NAMES.monitors,
    props: true,
    meta: {
      requiresAuth: true,
      breadCrumbFromParamName: true,
      params: ['issue', 'name'],
      hideBreadCrumb: true,
      breadCrumb: 'incident.tabs.monitors',
      background: BackgroundColors.SECONDARY,
      negativeMargin: true,
    },
    component: () => import('@/views/FrontendNextRouteView.vue'),
  },
  {
    path: 'issue/:issue/impacted-dashboards',
    name: INCIDENT_ROUTE_NAMES.impactedDashboards,
    props: true,
    meta: {
      requiresAuth: true,
      breadCrumbFromParamName: true,
      params: ['issue', 'name'],
      hideBreadCrumb: true,
      breadCrumb: 'incident.tabs.impacted_dashboards',
      background: BackgroundColors.SECONDARY,
      negativeMargin: true,
    },
    component: () => import('@/views/FrontendNextRouteView.vue'),
  },
  {
    path: 'issue/:issue/lineage',
    name: INCIDENT_ROUTE_NAMES.lineage,
    props: true,
    meta: {
      requiresAuth: true,
      breadCrumbFromParamName: true,
      params: ['issue', 'name'],
      hideBreadCrumb: true,
      breadCrumb: 'incident.tabs.lineage',
      background: BackgroundColors.SECONDARY,
      negativeMargin: true,
    },
    component: () => import('@/views/FrontendNextRouteView.vue'),
  },
  {
    path: 'issue/:issue/notifications',
    name: INCIDENT_ROUTE_NAMES.notifications,
    props: true,
    meta: {
      requiresAuth: true,
      breadCrumbFromParamName: true,
      params: ['issue', 'name'],
      hideBreadCrumb: true,
      breadCrumb: 'incident.tabs.notifications',
      background: BackgroundColors.SECONDARY,
      negativeMargin: true,
    },
    component: () => import('@/views/FrontendNextRouteView.vue'),
  }],
};

export default incidentsRoutes;
